var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9999 12C21.0063 16.1476 18.1774 19.7625 14.1499 20.7533C10.1223 21.7441 5.93921 19.8542 4.02066 16.177C2.10211 12.4997 2.945 7.98755 6.06169 5.25093C9.17837 2.51431 13.7617 2.26199 17.1599 4.63996L17.0499 4.31996C16.8732 3.78148 17.1664 3.20169 17.7049 3.02496C18.2434 2.84823 18.8232 3.14148 18.9999 3.67996L19.9999 6.67996C20.1005 6.98503 20.0484 7.31986 19.8599 7.57996C19.6632 7.85696 19.3393 8.01514 18.9999 7.99996H15.9999C15.4476 7.99996 14.9999 7.55224 14.9999 6.99996C15.0073 6.56568 15.2942 6.18585 15.7099 6.05996C13.0042 4.36891 9.49741 4.72148 7.18252 6.91729C4.86763 9.11309 4.33052 12.5964 5.87644 15.3876C7.42237 18.1787 10.6601 19.5712 13.7495 18.7738C16.8389 17.9763 18.9981 15.1906 18.9999 12C18.9999 11.4477 19.4476 11 19.9999 11C20.5522 11 20.9999 11.4477 20.9999 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetIcon);
export default __webpack_public_path__ + "static/media/reset_icon.d79385f20d63693627b2162b9f6c41af.svg";
export { ForwardRef as ReactComponent };